(function(){
  'use strict';

  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobileQuery=window.matchMedia('(max-width: 680px)');
  var progress=document.getElementById('lrProgress');
  var sticky=document.querySelector('[data-lr-sticky]');

  function onScroll(){
    var doc=document.documentElement;
    var max=Math.max(1,doc.scrollHeight-window.innerHeight);
    if(progress)progress.style.width=Math.min(100,(window.scrollY/max)*100)+'%';
    if(sticky)sticky.classList.toggle('is-visible',window.scrollY>window.innerHeight*.8);
  }
  window.addEventListener('scroll',onScroll,{passive:true});
  onScroll();

  var reveals=document.querySelectorAll('.lr-reveal');
  var motionReady=!mobileQuery.matches&&!reduced&&'IntersectionObserver' in window;
  if(motionReady){
    document.documentElement.classList.add('lr-motion');
    var observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        }
      });
    },{threshold:.12,rootMargin:'0px 0px -5% 0px'});
    reveals.forEach(function(el){observer.observe(el);});
  }else{
    reveals.forEach(function(el){el.classList.add('is-in');});
  }

  function syncOffer(form,radio){
    if(!form||!radio)return;
    form.querySelectorAll('[data-lr-choice]').forEach(function(choice){
      var input=choice.querySelector('input[type="radio"][name="id"]');
      var active=input===radio&&radio.checked;
      choice.classList.toggle('is-active',active);
      if(input)input.setAttribute('aria-checked',active?'true':'false');
    });

    var choice=radio.closest('[data-lr-choice]');
    var buy=form.querySelector('[data-lr-buy]');
    var stickyPrice=document.querySelector('[data-lr-sticky-price]');
    if(choice&&buy){
      var label='Commander — '+choice.dataset.price;
      buy.dataset.defaultLabel=label;
      if(!buy.classList.contains('is-loading'))buy.textContent=label;
    }
    if(choice&&stickyPrice)stickyPrice.textContent=choice.dataset.price;
  }

  document.querySelectorAll('[data-lr-product-form]').forEach(function(form){
    var radios=form.querySelectorAll('input[type="radio"][name="id"]');
    var selected=form.querySelector('input[type="radio"][name="id"]:checked:not(:disabled)');
    if(!selected){
      selected=form.querySelector('input[type="radio"][name="id"]:not(:disabled)');
      if(selected)selected.checked=true;
    }
    if(selected)syncOffer(form,selected);

    radios.forEach(function(radio){
      radio.addEventListener('change',function(){
        if(radio.checked)syncOffer(form,radio);
      });
    });

    form.addEventListener('submit',function(event){
      var current=form.querySelector('input[type="radio"][name="id"]:checked:not(:disabled)');
      var buy=form.querySelector('[data-lr-buy]');
      if(!current){
        event.preventDefault();
        var first=form.querySelector('input[type="radio"][name="id"]:not(:disabled)');
        if(first)first.focus();
        if(buy)buy.textContent='Choisissez une offre';
        return;
      }
      if(form.dataset.lrSubmitting==='true'){
        event.preventDefault();
        return;
      }
      if(form.dataset.lrFresh!=='1'){
        event.preventDefault();
        form.dataset.lrSubmitting='true';
        if(buy){
          if(!buy.dataset.defaultLabel)buy.dataset.defaultLabel=buy.textContent;
          buy.classList.add('is-loading');
          buy.setAttribute('aria-busy','true');
          buy.disabled=true;
          buy.textContent='Redirection sécurisée…';
        }
        var go=function(){
          form.dataset.lrFresh='1';
          form.dataset.lrSubmitting='false';
          if(buy)buy.disabled=false;
          if(form.requestSubmit)form.requestSubmit();
          else form.submit();
        };
        try{
          fetch('/cart/clear.js',{method:'POST'}).catch(function(){}).then(go,go);
        }catch(e){go();}
        return;
      }
      form.dataset.lrFresh='';
      form.dataset.lrSubmitting='true';
      if(buy){
        if(!buy.dataset.defaultLabel)buy.dataset.defaultLabel=buy.textContent;
        buy.classList.add('is-loading');
        buy.setAttribute('aria-busy','true');
        buy.disabled=true;
        buy.textContent='Redirection sécurisée…';
        window.setTimeout(function(){
          if(document.visibilityState==='visible'){
            form.dataset.lrSubmitting='false';
            buy.classList.remove('is-loading');
            buy.removeAttribute('aria-busy');
            buy.disabled=false;
            buy.textContent=buy.dataset.defaultLabel||'Commander';
          }
        },8000);
      }
    });
  });

  var range=document.querySelector('[data-lr-range]');
  var lab=document.querySelector('[data-lr-lab]');
  var temp=document.querySelector('[data-lr-temp]');
  var label=document.querySelector('[data-lr-label]');
  var values=[45,50,55,60,65];
  var labels=['Chaleur douce','Chaleur modérée','Chaleur équilibrée','Chaleur intense','Chaleur maximale'];
  var colors=['#eee8e4','#ede5e1','#ebe1de','#e9dcda','#e6d6d5'];

  function setHeat(index){
    index=Math.max(0,Math.min(values.length-1,index||0));
    if(temp)temp.textContent=values[index];
    if(label)label.textContent=labels[index];
    if(range){
      range.setAttribute('aria-valuenow',String(index));
      range.setAttribute('aria-valuetext',values[index]+' degrés — '+labels[index]);
    }
    if(lab){
      lab.style.background=colors[index];
      lab.style.setProperty('--lr-heat-scale',(1+index*.055).toFixed(2));
      lab.style.setProperty('--lr-heat-blur',(8+index*3)+'px');
      lab.style.setProperty('--lr-glow-size',(32+index*9)+'px');
    }
  }
  if(range){
    range.addEventListener('input',function(){setHeat(parseInt(range.value,10));});
    setHeat(parseInt(range.value,10));
  }

  document.querySelectorAll('[data-lr-mode]').forEach(function(mode){
    mode.addEventListener('click',function(){
      document.querySelectorAll('[data-lr-mode]').forEach(function(item){
        var active=item===mode;
        item.classList.toggle('is-active',active);
        item.setAttribute('aria-pressed',active?'true':'false');
      });
      var modeLabel=document.querySelector('[data-lr-mode-label]');
      if(modeLabel)modeLabel.textContent=mode.dataset.label||mode.textContent;
    });
  });

  var stage=document.querySelector('[data-lr-stage]');
  document.querySelectorAll('[data-lr-thumb]').forEach(function(thumb){
    thumb.addEventListener('click',function(){
      document.querySelectorAll('[data-lr-thumb]').forEach(function(item){
        var active=item===thumb;
        item.classList.toggle('is-active',active);
        item.setAttribute('aria-pressed',active?'true':'false');
      });
      if(!stage)return;
      stage.style.opacity='0';
      window.setTimeout(function(){
        var show=function(){stage.style.opacity='1';};
        stage.onload=show;
        stage.onerror=show;
        stage.removeAttribute('srcset');
        stage.src=mobileQuery.matches&&thumb.dataset.mobileSrc?thumb.dataset.mobileSrc:thumb.dataset.src;
        if(thumb.dataset.alt)stage.alt=thumb.dataset.alt;
        if(stage.complete)show();
      },reduced?0:150);
    });
  });

  document.querySelectorAll('.lr-autoplay-video').forEach(function(video){
    video.muted=true;
    video.setAttribute('muted','');
    video.setAttribute('playsinline','');
    var media=video.closest('.lr-hero__media,.lr-chapter__media,.lr-pvideo');
    var fallback=function(){if(media)media.classList.add('is-video-fallback');};
    var play=function(){
      if(reduced)return;
      var attempt=video.play();
      if(attempt&&attempt.catch)attempt.catch(function(){});
    };
    video.addEventListener('error',fallback);
    if(video.readyState>=2)play();
    else video.addEventListener('loadeddata',play,{once:true});
    document.addEventListener('visibilitychange',function(){
      if(!document.hidden&&video.paused)play();
    });
  });

  document.querySelectorAll('[data-lr-scrollto]').forEach(function(button){
    button.addEventListener('click',function(){
      var target=document.querySelector(button.dataset.lrScrollto);
      if(target)target.scrollIntoView({behavior:reduced?'auto':'smooth',block:'center'});
    });
  });
})();